/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockMoveBackIcon20Solid = forwardRef('TimeClockMoveBackIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.775 4.009A6.249 6.249 0 0 0 5.199 6H6a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1V4a1 1 0 0 1 2 0v.34a8.248 8.248 0 1 1-1.536 9.015 1 1 0 1 1 1.827-.814 6.249 6.249 0 1 0 7.484-8.532Z" }),
        React.createElement("path", { d: "M10.73 6.443a1 1 0 1 0-2 0v3.123a2.25 2.25 0 0 0 1.22 2.001l2.693 1.384a1 1 0 0 0 .914-1.779L10.865 9.79a.25.25 0 0 1-.136-.223V6.443Z" })));
});
